/* eslint-disable import/no-internal-modules */
import { LicenseManager } from 'ag-grid-enterprise';
import React from 'react';
import { render } from 'react-dom';
import { AG_GRID_LICENSE_KEY } from 'config/environment';
import { InitWorkerApi } from 'initWorker';
import { isLocalhost } from 'utils/is-localhost';
import { cacheServiceWorker } from 'vendor/cache-worker';
import { initDatadog, initDatadogRum } from 'vendor/datadog-rum';
import { initLogRocket } from 'vendor/log-rocket';
import { App } from './app';
import './index.css';
import 'react-cmdk/dist/cmdk.css';

initDatadog();
initDatadogRum();
setTimeout(() => {
  initLogRocket();
}, 3000);
if (AG_GRID_LICENSE_KEY != null) {
  LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);
}
if (!isLocalhost()) {
  cacheServiceWorker();
}

// disable MSW in development and when cypress is running
if (process.env.NODE_ENV === 'development' && !window.Cypress) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require, import/no-internal-modules
  // const { worker } = require('./mocks/browser');
  // worker.start();
}

if (window.location.hostname === 'localhost') {
  InitWorkerApi.setData();
}

render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
